import { render, staticRenderFns } from "./DeliverableListContacts.vue?vue&type=template&id=d680125a&"
import script from "./DeliverableListContacts.vue?vue&type=script&lang=js&"
export * from "./DeliverableListContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d680125a')) {
      api.createRecord('d680125a', component.options)
    } else {
      api.reload('d680125a', component.options)
    }
    module.hot.accept("./DeliverableListContacts.vue?vue&type=template&id=d680125a&", function () {
      api.rerender('d680125a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/DeliverableListContacts.vue"
export default component.exports